module.exports = __webpack_public_path__ + "static/img/js.25ab4d54.png";